const showNewsletterBanner = () => {
  $('#newsletter-banner').removeClass('dn');
};

const hideNewsletterBanner = () => {
  $('#newsletter-banner').addClass('dn');
};

const showNewsletterForm = () => {
  hideNewsletterBanner();
  $('#newsletter-form').removeClass('dn');
};

const hideNewsletterForm = () => {
  $('#newsletter-form').addClass('dn');
};

const shouldDisplayBanner = () => {
  if (!$('#newsletter-banner').length) return false;

  // Display the newsletter banner if the user has specified newsletter_banner as a param in the URL - This
  // makes it easy to test the banner and the newsletter form
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('newsletter_banner') === '1') return true;

  // Display banner if the user has viewed elgible pages a total of 2 times
  const currentViewCount = parseInt(window.localStorage.getItem('viewCount'), 10);
  if (!currentViewCount) {
    window.localStorage.setItem('viewCount', 1);
    return false;
  }
  window.localStorage.setItem('viewCount', (currentViewCount + 1));
  return currentViewCount + 1 === 2;
};

const triggerBannerShownGTMEvent = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'newsletterBannerPopUp'
  });
};

$(() => {
  $('#newsletter-banner-close-icon').on('click', hideNewsletterBanner);
  $('#newsletter-banner-button').on('click', showNewsletterForm);
  $('.js-newsletter-close').on('click', hideNewsletterForm);
  if (shouldDisplayBanner()) {
    showNewsletterBanner();
    triggerBannerShownGTMEvent();
  }
});

$('body').on('click', (e) => {
  if (e.target.classList.contains('modal-overlay')) hideNewsletterForm();
});
